import {
  CORE_SKILL_LEVELS,
  DIGITAL_SKILL_LEVELS,
  SCULPTURE_SKILL_LEVELS,
} from "./skillLevelConstants"

export const EVAL_CATEGORIES = {
  ART_SKILLS: "ART_SKILLS",
  SOCIAL_SKILLS: "SOCIAL_SKILLS",
  CREATIVITY: "CREATIVITY",
} as const

export const EVAL_CATEGORY_SORT_ORDER = [
  EVAL_CATEGORIES.ART_SKILLS,
  EVAL_CATEGORIES.CREATIVITY,
  EVAL_CATEGORIES.SOCIAL_SKILLS,
] as const

// Core skill level template IDs
export const OLD_CORE_EVAL_TEMPLATE_IDS_BY_LEVEL = {
  // new design - skill you start in determines template
  // evalTemplates[skill][isSkillUp]

  // NA exists to avoid type errors. It should never be used.
  NA: {
    true: "",
    false: "",
  },

  BG: {
    true: "tpl_tpqFDZbsLNKpkXPr6M",
    false: "tpl_D2f6mZ7SZR5Dq4FyGF",
  },
  P: {
    true: "tpl_5XX9rkC3M4b9Fx2xYt",
    false: "tpl_YJEx2nYfpXq4PJ5pdk",
  },
  BB: {
    true: "tpl_6GhyK96MtpJg4yDccN",
    false: "tpl_f6T6Gnrgatm46DZmPE",
  },
  B: {
    true: "tpl_SAHH47M76C927KmQ2x",
    false: "tpl_pN5Kmc7GbpYJYP5xRZ",
  },
  G: {
    true: "tpl_6MKxSJLFACNQnSexPd",
    false: "tpl_4Pkx942ckHFKHfbTgk",
  },
  L: {
    true: "tpl_5Eq4S6xdQNAJdp2bkX",
    false: "tpl_fAMSxNkD7MmERyEXs4",
  },
  Y: {
    true: "tpl_kKJS7RMHAGL9NFpSJr",
    false: "tpl_AxAKeEQPXtjHK4Tpkd",
  },
  O: {
    true: "tpl_49xGPnadRaxk9HsqGa",
    false: "tpl_NpAHaDYMXhmdQQkdKa",
  },
  R: {
    true: "tpl_aqcDtznrNXDqPdrDeR",
    false: "tpl_aqcDtznrNXDqPdrDeR",
  },
}

// Digital skill level template IDs
export const DIGITAL_EVAL_TEMPLATE_IDS_BY_LEVEL = {
  RO: {
    true: "tpl_khhJrM2geJq4t72bse",
    false: "tpl_Hk3rXzKMKH2c9dFXzR",
  },
  TA: {
    true: "tpl_mA4xPYc5XEezRDhzKA",
    false: "tpl_hq73RXEchEnFYJfXLE",
  },
  UBB: {
    true: "tpl_zQ22ftzgM2ks2QpxFj",
    false: "tpl_Pf3J2cJbshA5XAfDhE",
  },
  BUP: {
    true: "tpl_XrfbTfnt73xbndyYD2",
    false: "tpl_Px42g3dfy5dLcs7HFP",
  },
  HD: {
    true: "tpl_EgCQNgAJ6NMeQCc2N6",
    false: "tpl_mCr9C7FmRJkekgnye5",
  },
  YUM: {
    true: "tpl_9QnDApxkQeTEzsjNGC",
    false: "tpl_jehSdsmgbzM4smEPf5",
  },
  PIJ: {
    true: "tpl_xFSjPhrrEZLhkY9rHH",
    false: "tpl_FnaX7FHrdTE6pEnDzK",
  },
  THT: {
    true: "tpl_jbDTpfczCbRQnLHqZ7",
    false: "tpl_6Cy6QE25YR5etsJ3y6",
  },
  HI: {
    true: "tpl_ZkgxNbYxQXKPpXkLDL",
    false: "tpl_ZkgxNbYxQXKPpXkLDL",
  },
}

// Sculpture skill level template IDs using universal templates for testing
export const SCULPTURE_EVAL_TEMPLATE_IDS_BY_LEVEL = {
  ST: {
    true: "tpl_khhJrM2geJq4t72bse", // 01-LEVELUP-BG-P v3 UNIVERSAL.pdf (level up to P)
    false: "tpl_Hk3rXzKMKH2c9dFXzR", // 01-BG-BG UNIVERSAL 422.pdf (same level)
  },
  LA: {
    true: "tpl_mA4xPYc5XEezRDhzKA", // 02-LEVELUP-P-BB UNIVERSAL 422.pdf (level up to BB)
    false: "tpl_hq73RXEchEnFYJfXLE", // 03-P-P UNIVERSAL 422.pdf (same level)
  },
  GRB: {
    true: "tpl_zQ22ftzgM2ks2QpxFj", // 03-LEVELUP-BB-B UNIVERSAL 422.pdf (level up to B)
    false: "tpl_Pf3J2cJbshA5XAfDhE", // 05-BB-BB UNIVERSAL 422.pdf (same level)
  },
  EB: {
    true: "tpl_XrfbTfnt73xbndyYD2", // 04-LEVELUP-B-G UNIVERSAL 422.pdf (level up to G)
    false: "tpl_Px42g3dfy5dLcs7HFP", // 07-B-B UNIVERSAL 422.pdf (same level)
  },
  MAT: {
    true: "tpl_EgCQNgAJ6NMeQCc2N6", // 05-LEVELUP-G-L UNIVERSAL 422.pdf (level up to L)
    false: "tpl_mCr9C7FmRJkekgnye5", // 09-G-G UNIVERSAL 422.pdf (same level)
  },
  MEM: {
    true: "tpl_9QnDApxkQeTEzsjNGC", // 06-LEVELUP-L-Y UNIVERSAL 422.pdf (level up to Y)
    false: "tpl_jehSdsmgbzM4smEPf5", // 11-L-L UNIVERSAL 422.pdf (same level)
  },
  LE: {
    true: "tpl_xFSjPhrrEZLhkY9rHH", // 07-LEVELUP-Y-O UNIVERSAL 422.pdf (level up to O)
    false: "tpl_FnaX7FHrdTE6pEnDzK", // 13-Y-Y v3 UNIVERSAL 422.pdf (same level)
  },
  MA: {
    true: "tpl_jbDTpfczCbRQnLHqZ7", // 08-LEVELUP-O-R UNIVERSAL 422.pdf (level up to R)
    false: "tpl_6Cy6QE25YR5etsJ3y6", // 15-O-O UNIVERSAL 422.pdf (same level)
  },
  CH: {
    true: "tpl_ZkgxNbYxQXKPpXkLDL", // 09-LEVELUP-R-R UNIVERSAL 422.pdf (stays at R)
    false: "tpl_ZkgxNbYxQXKPpXkLDL", // 09-LEVELUP-R-R UNIVERSAL 422.pdf (stays at R)
  },
}

// Array of all universal template IDs
// export const SCULPTURE_UNIVERSAL_TEMPLATE_IDS = [
//   "tpl_khhJrM2geJq4t72bse", // 01-LEVELUP-BG-P v3 UNIVERSAL.pdf
//   "tpl_Hk3rXzKMKH2c9dFXzR", // 01-BG-BG UNIVERSAL 422.pdf
//   "tpl_mA4xPYc5XEezRDhzKA", // 02-LEVELUP-P-BB UNIVERSAL 422.pdf
//   "tpl_hq73RXEchEnFYJfXLE", // 03-P-P UNIVERSAL 422.pdf
//   "tpl_zQ22ftzgM2ks2QpxFj", // 03-LEVELUP-BB-B UNIVERSAL 422.pdf
//   "tpl_Pf3J2cJbshA5XAfDhE", // 05-BB-BB UNIVERSAL 422.pdf
//   "tpl_XrfbTfnt73xbndyYD2", // 04-LEVELUP-B-G UNIVERSAL 422.pdf
//   "tpl_Px42g3dfy5dLcs7HFP", // 07-B-B UNIVERSAL 422.pdf
//   "tpl_EgCQNgAJ6NMeQCc2N6", // 05-LEVELUP-G-L UNIVERSAL 422.pdf
//   "tpl_mCr9C7FmRJkekgnye5", // 09-G-G UNIVERSAL 422.pdf
//   "tpl_9QnDApxkQeTEzsjNGC", // 06-LEVELUP-L-Y UNIVERSAL 422.pdf
//   "tpl_jehSdsmgbzM4smEPf5", // 11-L-L UNIVERSAL 422.pdf
//   "tpl_xFSjPhrrEZLhkY9rHH", // 07-LEVELUP-Y-O UNIVERSAL 422.pdf
//   "tpl_FnaX7FHrdTE6pEnDzK", // 13-Y-Y v3 UNIVERSAL 422.pdf
//   "tpl_jbDTpfczCbRQnLHqZ7", // 08-LEVELUP-O-R UNIVERSAL 422.pdf
//   "tpl_6Cy6QE25YR5etsJ3y6", // 15-O-O UNIVERSAL 422.pdf
//   "tpl_ZkgxNbYxQXKPpXkLDL", // 09-LEVELUP-R-R UNIVERSAL 422.pdf
// ]

// New universal evaluation template IDs with level-up support
export const NEW_UNIVERSAL_EVAL_TEMPLATE_IDS_BY_LEVEL = {
  BG: {
    true: "tpl_khhJrM2geJq4t72bse", // 01-LEVELUP-BG-P v3 UNIVERSAL.pdf (level up to P)
    false: "tpl_Hk3rXzKMKH2c9dFXzR", // 01-BG-BG UNIVERSAL 422.pdf (same level)
  },
  P: {
    true: "tpl_mA4xPYc5XEezRDhzKA", // 02-LEVELUP-P-BB UNIVERSAL 422.pdf (level up to BB)
    false: "tpl_hq73RXEchEnFYJfXLE", // 03-P-P UNIVERSAL 422.pdf (same level)
  },
  BB: {
    true: "tpl_zQ22ftzgM2ks2QpxFj", // 03-LEVELUP-BB-B UNIVERSAL 422.pdf (level up to B)
    false: "tpl_Pf3J2cJbshA5XAfDhE", // 05-BB-BB UNIVERSAL 422.pdf (same level)
  },
  B: {
    true: "tpl_XrfbTfnt73xbndyYD2", // 04-LEVELUP-B-G UNIVERSAL 422.pdf (level up to G)
    false: "tpl_Px42g3dfy5dLcs7HFP", // 07-B-B UNIVERSAL 422.pdf (same level)
  },
  G: {
    true: "tpl_EgCQNgAJ6NMeQCc2N6", // 05-LEVELUP-G-L UNIVERSAL 422.pdf (level up to L)
    false: "tpl_mCr9C7FmRJkekgnye5", // 09-G-G UNIVERSAL 422.pdf (same level)
  },
  L: {
    true: "tpl_9QnDApxkQeTEzsjNGC", // 06-LEVELUP-L-Y UNIVERSAL 422.pdf (level up to Y)
    false: "tpl_jehSdsmgbzM4smEPf5", // 11-L-L UNIVERSAL 422.pdf (same level)
  },
  Y: {
    true: "tpl_xFSjPhrrEZLhkY9rHH", // 07-LEVELUP-Y-O UNIVERSAL 422.pdf (level up to O)
    false: "tpl_FnaX7FHrdTE6pEnDzK", // 13-Y-Y v3 UNIVERSAL 422.pdf (same level)
  },
  O: {
    true: "tpl_jbDTpfczCbRQnLHqZ7", // 08-LEVELUP-O-R UNIVERSAL 422.pdf (level up to R)
    false: "tpl_6Cy6QE25YR5etsJ3y6", // 15-O-O UNIVERSAL 422.pdf (same level)
  },
  R: {
    true: "tpl_ZkgxNbYxQXKPpXkLDL", // 09-LEVELUP-R-R UNIVERSAL 422.pdf (stays at R)
    false: "tpl_ZkgxNbYxQXKPpXkLDL", // 09-LEVELUP-R-R UNIVERSAL 422.pdf (stays at R)
  },
}

export const EVAL_LEVEL_ICONS = {
  // Core skill levels
  BG: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FBG.png?alt=media&token=9acb9cde-dae9-4ab8-aa05-83287d0b6203",
  P: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FP.png?alt=media&token=7410ef1f-6642-421e-8631-6fdc5a83618b",
  BB: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FBB.png?alt=media&token=dd3ac8ed-e425-4b75-b1ad-b30aee0fafe6",
  B: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FB.png?alt=media&token=b27dd741-e14e-427a-b5af-75120137ef78",
  G: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FG.png?alt=media&token=f3e13f09-7742-40ff-b5c0-0390cfe090a8",
  L: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FL.png?alt=media&token=2a6c61ca-1cd5-4044-beb5-816c11da90af",
  Y: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FY.png?alt=media&token=190f1c8c-9b2f-4e85-801b-0d17150be0e8",
  O: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FO.png?alt=media&token=94af5a7d-17a1-4bbb-9a81-8418809fe7a2",
  R: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FR.png?alt=media&token=6cc5d2c4-c2ab-4c54-ae11-5a55cbfbb370",

  // Digital skill levels
  RO: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F1RO.png?alt=media&token=2d96d3b9-e746-41c7-900c-c86e31586760",
  TA: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F2TA.png?alt=media&token=262807aa-6373-48a8-9aa3-1a0ced3accf5",
  UBB: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F3UBB.png?alt=media&token=5fa321bf-2f9e-4bca-85ee-5f845b4b8112",
  BUP: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F4BUP.png?alt=media&token=af3f254b-31b5-4abb-935d-e7220f4d2929",
  HD: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F5HD.png?alt=media&token=fe1a6e7c-292b-4027-8059-4f5649820c0c",
  YUM: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F6YUM.png?alt=media&token=8fe237c8-c7d8-4702-a5df-1678ab16af81",
  PIJ: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F7PIJ.png?alt=media&token=46250dea-58b4-4e5d-b7b5-2871bc9f6a5c",
  THT: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F8THT.png?alt=media&token=571edb07-b3d3-4f7c-90b9-a09a43e99dd2",
  HI: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FDigital%2F9HI.png?alt=media&token=e2835f41-4e5b-4803-b10f-ac309dce687e",

  // Sculpture skill levels
  ST: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F1ST.png?alt=media&token=4544e1b2-b5eb-45c7-b108-62db11aa638a",
  LA: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F2LA.png?alt=media&token=eba7477d-cad7-48e1-97a5-e547bbcfef05",
  GRB: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F3GRB.png?alt=media&token=eeef37af-7bf4-4cc2-9c8c-dbf7823a0403",
  EB: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F4EB.png?alt=media&token=ab5042fc-755f-4b3d-a975-228ec04fb2e6",
  MAT: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F5MAT.png?alt=media&token=c94826ce-c47c-4771-b955-febd63811003",
  MEM: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F6MEM.png?alt=media&token=28a868dd-0f59-4e2b-a77d-81f6b2af1fe9",
  LE: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F7LE.png?alt=media&token=a73fd4f0-9b92-48fe-ac11-1b26cc2e6614",
  MA: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F8MA.png?alt=media&token=307c7a86-8dac-4e07-b0a8-f2e54435af89",
  CH: "https://firebasestorage.googleapis.com/v0/b/hongyunart-55f89.appspot.com/o/SkillIcons%2FSculpture%2F9CH.png?alt=media&token=0ad4f506-5d3f-43bb-b8b3-4169724ca1e5",
}

export const EVAL_LEVEL_LABELS_BY_LEVEL = {
  // Core skill levels
  [CORE_SKILL_LEVELS.BG]: "Bubblegum 1",
  [CORE_SKILL_LEVELS["BG^"]]: "Bubblegum 2",
  [CORE_SKILL_LEVELS.P]: "Purple 1",
  [CORE_SKILL_LEVELS["P^"]]: "Purple 2",
  [CORE_SKILL_LEVELS.BB]: "Blueberry 1",
  [CORE_SKILL_LEVELS["BB^"]]: "Blueberry 2",
  [CORE_SKILL_LEVELS.B]: "Blue 1",
  [CORE_SKILL_LEVELS["B^"]]: "Blue 2",
  [CORE_SKILL_LEVELS.G]: "Green 1",
  [CORE_SKILL_LEVELS["G^"]]: "Green 2",
  [CORE_SKILL_LEVELS.L]: "Lime 1",
  [CORE_SKILL_LEVELS["L^"]]: "Lime 2",
  [CORE_SKILL_LEVELS.Y]: "Yellow 1",
  [CORE_SKILL_LEVELS["Y^"]]: "Yellow 2",
  [CORE_SKILL_LEVELS.O]: "Orange 1",
  [CORE_SKILL_LEVELS["O^"]]: "Orange 2",
  [CORE_SKILL_LEVELS.R]: "Red",

  // Digital skill levels
  [DIGITAL_SKILL_LEVELS.RO]: "Rose Milk 1",
  [DIGITAL_SKILL_LEVELS["RO^"]]: "Rose Milk 2",
  [DIGITAL_SKILL_LEVELS.TA]: "Taro 1",
  [DIGITAL_SKILL_LEVELS["TA^"]]: "Taro 2",
  [DIGITAL_SKILL_LEVELS.UBB]: "Ube Berry 1",
  [DIGITAL_SKILL_LEVELS["UBB^"]]: "Ube Berry 2",
  [DIGITAL_SKILL_LEVELS.BUP]: "Butterfly Pea 1",
  [DIGITAL_SKILL_LEVELS["BUP^"]]: "Butterfly Pea 2",
  [DIGITAL_SKILL_LEVELS.HD]: "Honeydew 1",
  [DIGITAL_SKILL_LEVELS["HD^"]]: "Honeydew 2",
  [DIGITAL_SKILL_LEVELS.YUM]: "Yuzu Mint 1",
  [DIGITAL_SKILL_LEVELS["YUM^"]]: "Yuzu Mint 2",
  [DIGITAL_SKILL_LEVELS.PIJ]: "Pineapple Jelly 1",
  [DIGITAL_SKILL_LEVELS["PIJ^"]]: "Pineapple Jelly 2",
  [DIGITAL_SKILL_LEVELS.THT]: "Thai Tea 1",
  [DIGITAL_SKILL_LEVELS["THT^"]]: "Thai Tea 2",
  [DIGITAL_SKILL_LEVELS.HI]: "Hibiscus",

  // Sculpture skill levels
  [SCULPTURE_SKILL_LEVELS.ST]: "Strawberry 1",
  [SCULPTURE_SKILL_LEVELS["ST^"]]: "Strawberry 2",
  [SCULPTURE_SKILL_LEVELS.LA]: "Lavender 1",
  [SCULPTURE_SKILL_LEVELS["LA^"]]: "Lavender 2",
  [SCULPTURE_SKILL_LEVELS.GRB]: "GrapeBerry 1",
  [SCULPTURE_SKILL_LEVELS["GRB^"]]: "GrapeBerry 2",
  [SCULPTURE_SKILL_LEVELS.EB]: "EarlBlue 1",
  [SCULPTURE_SKILL_LEVELS["EB^"]]: "EarlBlue 2",
  [SCULPTURE_SKILL_LEVELS.MAT]: "Matcha 1",
  [SCULPTURE_SKILL_LEVELS["MAT^"]]: "Matcha 2",
  [SCULPTURE_SKILL_LEVELS.MEM]: "Mellowmint 1",
  [SCULPTURE_SKILL_LEVELS["MEM^"]]: "Mellowmint 2",
  [SCULPTURE_SKILL_LEVELS.LE]: "Lemon 1",
  [SCULPTURE_SKILL_LEVELS["LE^"]]: "Lemon 2",
  [SCULPTURE_SKILL_LEVELS.MA]: "Mango 1",
  [SCULPTURE_SKILL_LEVELS["MA^"]]: "Mango 2",
  [SCULPTURE_SKILL_LEVELS.CH]: "Cherry",
}
